import {Component, Input, ChangeDetectionStrategy, ViewChildren, QueryList} from '@angular/core';
import {IconDetails} from '@core/interfaces/common/pages';
import {NavigationStart, Router, RouterEvent} from '@angular/router';
import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {debounceTime, filter, takeUntil} from 'rxjs/operators';
import {NbPopoverDirective} from '@nebular/theme';

@Component({
    selector: 'ngx-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent extends Unsubscribable {
    @Input() items: any[];
    @Input() expanded: boolean;

    @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;

    constructor(private router: Router) {
        super();
        this.closeMenusAfterNavigation();
    }

    public getIconDetails(active: boolean, icon: IconDetails) {
        let retIcon = icon;
        if (!active) {
            retIcon = {
                ...icon,
                icon: icon.icon + '-outline',
            };
        }
        return retIcon;
    }

    private closeMenusAfterNavigation(): void {
        // This method avoids menus being stuck open due to rapid navigation events
        this.router.events
            .pipe(
                takeUntil(this.unsubscribe$),
                filter((event: RouterEvent) => event instanceof NavigationStart),
                debounceTime(1000),
            )
            .subscribe(() => {
                if (!!this.popovers) {
                    this.popovers.forEach((popover) => {
                        popover.hide();
                    });
                }
            });
    }
}
